class ShopController extends AbstractEntityEditController
	@register()
	@inject '$scope',
		'translate'
		'dataSources'
		'priceRegions'
		'productCategories'
		'languages'
		'layoutTemplates'
		'vatRateOverrideGroups'
		'registers'
		'shop'
		'shopGroups'
		'shopConfigurations'
		'shopTables'
		'stockLocations'
		'ProductCategoryRepository'
		'RegisterRepository'
		'SalesTaxRepository'
		'ShopGroupRepository'
		'ShopRepository'
		'ShopTableRepository'
		'StockLocationRepository'
		'ShopVisitorCountRepository'
		'TimezoneService'
		'ToastService'
		'Guid'
		'CopyService'
		'ConfigurationService'
		'InfrasecRegisterService'
		'DataSourceRepository'
		'EntityAttributeService'
		'MessageTerminal'
		'UserInformation'
		'ShopDeviceService'
		'localStorageService'
		'types': 'BACKEND_SALES_TAX_TYPE'
		'BACKEND_REGISTER_ENTITY_TYPE'

	initialize: ->
		@mainCrud.entityType = 'general.shop'
		@mainCrud.entityTitle = 'wbo.new.shop'

		@unifiedSalesTaxCategories = []
		@isAddressRequired = false
		@useUnifiedSalesTaxCategories = true
		@timezones = @TimezoneService.getTimezones()
		@stockLocations = @CopyService.copy @stockLocations
		@shopVisitorCounts = []
		@editedShopVisitorCounts = []
		@registerForClosing = null
		@previuosRegisterForClosing = null

		@salesTax =
			order:
				"#{@types.STATE}": 1
				"#{@types.COUNTY}": 2
				"#{@types.CITY}": 3
				"#{@types.DISTRICT}": 4
				"#{@types.OTHER}": 9999
			address:
				lookup_address: ''
				normalized_address: null
				error: false

		@salesTaxTypes = _.mapObject(
			@salesTax.order,
			(value, key) =>
				return {
					id: key,
					name: key,
					order: value,
				}
		)

		@shopConfigFilter = [
			'Shared.Receipt.Logo.ImageFile'
			'Backoffice.Setting.Order.Status.Cancelled.Message'
			'Backoffice.Setting.Order.Status.Prepared.Message'
			'Backoffice.Setting.Order.Status.Delivered.Message'
			'POS.Setting.Adyen.ApiKey'
			'POS.Setting.Adyen.MerchantAccount'
			'POS.Setting.Adyen.URLPrefix'
			'POS.Setting.Adyen.Key.Identifier'
			'POS.Setting.Adyen.Key.Passphrase'
			'POS.Setting.Adyen.Key.Version'
		]

		@dayTemplate =
			open_from: null
			open_to: null
		@datePickerConfiguration =
			singleDatePicker: true
			startDate: moment()

		@filterDTO = new FilterDTO({
			searchConfiguration: {timestamp: {property: 'timestamp', label: 'general.date', type: 'date'}}
			sortProperty: 'timestamp'
			pageSize: 10
			count: 0
		})

		@initializeConfigs()

		user = @UserInformation.getSubUser()

		#Adding and handling Translations for create.stock.location model#
		if @ConfigurationService.isEnabled('Backoffice.ShopManagement.Shops.EnableCreateStockLocation') && _.isEmpty(user?.shops)
			@stockLocations.push({id: -1, name: @translate('create.stock.location')})

		if @shop.id?
			@mainCrud.entityTitle = @shop.name
			@mainCrud.isNewEntity = false
			@mainCrud.showSave = @ConfigurationService.isEnabled('Backoffice.ShopManagement.Shops.EnableShopEdit')

			@shop.shop_groups = @shopGroups
			@shop.data_sources = @dataSources
			@shop.vipps =
				enabled: !_.isEmpty(@shop.additional_data?.vipps_enabled)
				configuration_already_set: !_.isEmpty(@shop.additional_data?.vipps_configuration)

			@searchShopVisitorCounts()

			entityTypes = [
				@BACKEND_REGISTER_ENTITY_TYPE.REGISTER,
				@BACKEND_REGISTER_ENTITY_TYPE.POS
			]

			registeredForClosing = _.find(
				@registers,
				(register) ->
					register.is_for_closing_external_orders == '1' && entityTypes.includes(register.entity_type)
			)

			if registeredForClosing
				@registerForClosing = registeredForClosing.id
				@previuosRegisterForClosing = registeredForClosing.id
		else
			@mainCrud.showSave = @ConfigurationService.isEnabled('Backoffice.ShopManagement.Shops.EnableShopCreation')
			@mainCrud.isNewEntity = true
			@shop =
				id: @Guid.generate()
				price_region_id: @priceRegions[0].id
				stock_location_id: @stockLocations[0].id
				sales_taxes: []

		@tabs = [
			{
				title: 'wbo.shop.tabs.details'
				selector: '#tab-shop-details'
			}
			{
				title: 'wbo.shop.tabs.openinghours'
				selector: '#tab-shop-opening-hours'
				disabled: !@canUseOpeningHours
			}
			{
				title: 'wbo.shop.tabs.tables',
				selector: '#tab-shop-tables',
				disabled: @mainCrud.isNewEntity || !@tablesEnabled
			}
			{
				title: 'wbo.shop.tabs.vipps'
				selector: '#tab-shop-vipps-settings'
				disabled: !@vippsEnabled
			}
			{
				title: 'wbo.shop.tabs.ordin'
				selector: '#tab-shop-ordin-settings'
				disabled: !@isOrdinEnabled
			}
			{
				title: 'wbo.tab.configuration'
				selector: '#tab-shop-configurations'
				disabled: @mainCrud.isNewEntity
			}
			{
				title: 'wbo.shop.tabs.visitor_counts'
				selector: '#tab-shop-visitor-counts'
				disabled: @mainCrud.isNewEntity || !@isVisitorCountEnabled
			}
			{
				title: 'wbo.title.salestaxrate.list'
				selector: '#tab-sales-tax'
				disabled: !@isSalesTaxEnabled
			}
			{
				title: 'wbo.shop.tabs.devices'
				selector: '#tab-device-status'
				disabled: @mainCrud.isNewEntity || !@isPusherEnabled
			}
		]

		@attributesService = @EntityAttributeService.getNewInstance()
		@attributesService.setEntity @shop, 'BACKEND_SHOP_ATTRIBUTE_TYPE', {infrasec_external_shop_id: null}

		@initializeSalesTax()
		@initializeOrdin()
		@initializeInfrasec()
		@initializeShopOpeningHours()
		@initializeShopTables()

		if !@mainCrud.isNewEntity && @isPusherEnabled
			@ShopDeviceService.initializeDevices(@shop.id, @registers)

	initializeSalesTax: ->
		if !@isSalesTaxEnabled
			return

		@useUnifiedSalesTaxCategories = true

		unifiedCategories = null

		for salesTax in @shop.sales_taxes
			salesTax.$order = @salesTax.order[salesTax.type] || @salesTax.order.US_OTHER_SALES_TAX
			salesTax.percentage = parseFloat((salesTax.percentage * 100).toFixed(3))

			categories = []

			if @useUnifiedSalesTaxCategories == true
				if unifiedCategories == null
					unifiedCategories = @CopyService.copy(salesTax.excluded_product_categories).sort()
				else
					@useUnifiedSalesTaxCategories = _.isEqual(salesTax.excluded_product_categories.sort(), unifiedCategories)

			for excludedCategoryId in salesTax.excluded_product_categories
				category = _.find(@productCategories, {id: excludedCategoryId})

				if category?
					categories.push category

			salesTax.excluded_product_categories = categories

		if unifiedCategories != null
			@unifiedSalesTaxCategories = []

			if @useUnifiedSalesTaxCategories
				for unifiedCategoryId in unifiedCategories
					@unifiedSalesTaxCategories.push(_.find(@productCategories, {id: unifiedCategoryId}))

		@$scope.$watchGroup ['vm.shop.address', 'vm.shop.zipcode', 'vm.shop.city', 'vm.shop.country'],
			=> @updateSalesTaxLookupAddress()

		@updateSalesTaxLookupAddress()

		@manualSalesTax = @localStorageService.get('sales_tax.manual') ? false

		types = Object.values(@types)

		for salesTax in @shop.sales_taxes
			if !types.includes(salesTax.type)
				@manualSalesTax = true

				break

	initializeOrdin: ->
		if !@isOrdinEnabled
			return

		@shop.additional_data ?= {}
		@shop.additional_data.ordin_configuration =
			orders_preparation_time: @shop.additional_data.ordin_configuration?.orders_preparation_time ? 15
			stop_receiving_orders: @shop.additional_data.ordin_configuration?.stop_receiving_orders ? false

	initializeInfrasec: ->
		@infrasec = @InfrasecRegisterService
		@infrasec.init()
		hasExternalId = @attributesService.hasAttribute 'infrasec_external_shop_id'

		if hasExternalId
			@isAddressRequired = true
			@isExternalIdInitiallySet = true

	initializeConfigs: ->
		@allowImageEdit = @ConfigurationService.getValue('Backoffice.Setting.Cdn.Url') == null
		@isShopGroupVisible = @ConfigurationService.isEnabled('Backoffice.ShopManagement.Shops.EnableShopGroups')
		@isDataSourcesVisible = @ConfigurationService.isEnabled("Backoffice.ShopManagement.Shops.EnableDataSources")
		@isLayoutTemplatesVisible = @ConfigurationService.isEnabled('Backoffice.Permission.LayoutTemplates.Enabled')
		@isExternalOrderClosingEnabled = @ConfigurationService.isEnabled('Shared.Setting.ExternalOrderClosing.Enabled')
		@canUseOpeningHours = @ConfigurationService.isEnabled('Backoffice.ShopManagement.Shops.EnableOpeningHours')
		@vippsEnabled = @ConfigurationService.isEnabled('Shared.Setting.Integrations.Vipps.Enabled')
		@isVisitorCountEnabled = @ConfigurationService.isEnabled('Backoffice.Setting.VisitorCount.Enabled')
		@isVatRateOverrideGroupEnabled = @ConfigurationService.isEnabled('Shared.Setting.LinkShopToVatRateOverrideGroup.Enabled') &&
			!_.isEmpty(@vatRateOverrideGroups)
		@tablesEnabled = @ConfigurationService.isEnabled('Shared.Setting.Tables.Enabled')
		@isOrdinEnabled = @ConfigurationService.isEnabled('Backoffice.Setting.Integrations.EnableOrdin')
		@isSalesTaxEnabled = @ConfigurationService.isEnabled('Shared.Setting.SalesTax.Enabled')
		@isPusherEnabled = @ConfigurationService.isEnabled('Shared.Setting.Pusher.Changes.Enabled')

		if @ConfigurationService.isEnabled 'POS.WebInterface.WebInterface.Enabled'
			@shopConfigFilter.push('POS.WebInterface.WebInterfaceURL')

		@isAddressRequired = @isSalesTaxEnabled ||
			@ConfigurationService.isEnabled('Shared.Setting.Integrations.FiskalyPT.Enabled') ||
			@ConfigurationService.isEnabled('Shared.Setting.Integrations.FiskalyIT.Enabled')

	initializeShopOpeningHours: ->
		if @canUseOpeningHours
			@weekdays = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday']
			@mappedOpeningHours = [
				{day: 'monday',  week_day: 'MON'},
				{day: 'tuesday', week_day: 'TUE'},
				{day: 'wednesday', week_day: 'WED'},
				{day: 'thursday', week_day: 'THU'},
				{day: 'friday', week_day: 'FRI'},
				{day: 'saturday', week_day: 'SAT'},
				{day: 'sunday', week_day: 'SUN'}
			]

			currentDate = moment().format('YYYY-MM-DD')

			# Do NOT refactor this code to use moment.js because it will use timezones, while
			# timepickers here should be relative time and never affected by timezones
			@timePicker =
				min: new Date(currentDate + ' 00:00:00')
				max: new Date(currentDate + ' 23:59:59')

			if !@mainCrud.isNewEntity && !_.isEmpty(@shop.shop_opening_hours)
				@mapOpeningHours()

	initializeShopTables: ->
		if !@tablesEnabled
			return

		@tablesToDelete = []
		@resetNewTable()

		for table in @shopTables
			table.$new = false
			table.$dirty = false

	updateSalesTaxLookupAddress: ->
		@salesTax.address.lookup_address = _.filter([@shop.address, @shop.zipcode, @shop.city, @shop.country]).join(', ')

	toggleManualSalesTax: ->
		@manualSalesTax = !@manualSalesTax

		@localStorageService.set('sales_tax.manual', @manualSalesTax)

	save: ->
		@saveShopVisitorCounts()
			.then =>
				@saveStockLocation().then => @saveShop()
			.catch (response) =>
				@handleErrors response

	delete: ->
		@deleteEntity @ShopRepository, @shop

	mapOpeningHours: ->
		currentDate = moment().format('YYYY-MM-DD')

		for openingHour in @shop.shop_opening_hours
			weekday = _.find(
				@mappedOpeningHours,
				(hour) ->
					return (hour.week_day == openingHour.week_day)
				)

			if weekday?
				if !_.isEmpty(openingHour.open_from)
					# Do NOT refactor this code to use moment.js because it will use timezones, while
					# timepickers here should be relative time and never affected by timezones
					weekday.open_from = new Date(currentDate + ' ' + openingHour.open_from)
				else
					weekday.open_from = null

				if !_.isEmpty(openingHour.open_to)
					weekday.open_to = new Date(currentDate + ' ' + openingHour.open_to)
				else
					weekday.open_to = null

				weekday.closed = (openingHour.open_from == null || openingHour.open_to == null)

	parseOpeningHours: ->
		@shop.shop_opening_hours = []

		formatTime = (date) =>
			pad = (value) => "#{value}".padStart(2, 0)

			return "#{pad(date.getHours())}:#{pad(date.getMinutes())}:00"

		for openingHour in @mappedOpeningHours
			data =
				open_from: null
				open_to: null
				week_day: openingHour.week_day

			if openingHour.closed || !openingHour.open_from?
				openingHour.closed = true
			else
				data.open_from = formatTime(openingHour.open_from)
				data.open_to = formatTime(openingHour.open_to)

			@shop.shop_opening_hours.push data

	saveStockLocation: ->
		if @shop.stock_location_id != -1
			return @StockLocationRepository.resolve()

		return @StockLocationRepository
			.save {
				'name': @shop.name,
				'zipcode': @shop.zipcode,
				'city': @shop.city,
				'address': @shop.address,
				'country': @shop.country
			}
		.then (response) =>
			@shop.stock_location_id = response.data.id
		.catch (response) =>
			@handleErrors response, 'general.stock.location'

	saveShop: ->
		if @canUseOpeningHours
			@parseOpeningHours()

		saveShopDetails = =>
			@attributesService.persistAttributes()

			shop = @CopyService.copy(@shop, 'image')

			shop.shop_groups = _.pluck(@shopGroups, 'id')
			shop.data_sources = _.pluck(@dataSources, 'id')

			for salesTax in shop.sales_taxes
				salesTax.percentage = parseFloat((salesTax.percentage / 100).toFixed(5))
				salesTax.excluded_product_categories = _.pluck(salesTax.excluded_product_categories, 'id')

			return @ShopRepository.saveWithAttachment shop, @mainCrud.isNewEntity

		saveTables = =>
			if !@tablesEnabled
				return

			for table in @shopTables
				if !table.$dirty && !table.$new
					return

				tableCopy = @CopyService.copy(table, 'image')

				@ShopTableRepository
					.saveWithAttachment(tableCopy, table.$new)
					.then (response) =>
						@CopyService.copy(response.data, null, table)
						table.$dirty = false
						table.$new = false
					.catch (response) =>
						@handleErrors response, 'general.shop.table'

			for table in @tablesToDelete
				@ShopTableRepository
					.delete(table.id)
					.then =>
						@tablesToDelete = _.without(@tablesToDelete, table)
					.catch (response) =>
						@handleErrors response, 'general.shop.table'

		clearRegisterForClosing = =>
			if !@previuosRegisterForClosing || @registerForClosing == @previuosRegisterForClosing
				return

			model =
				id: @previuosRegisterForClosing
				is_for_closing_external_orders: false

			@RegisterRepository.save model, false, true

		saveRegisterForClosing = =>
			if !@registerForClosing
				return

			model =
				id: @registerForClosing
				is_for_closing_external_orders: true

			@RegisterRepository
				.save(model, false, true)
				.then => @previuosRegisterForClosing = @registerForClosing

		saveShopDetails()
			.then(saveTables)
			.then(clearRegisterForClosing)
			.then(saveRegisterForClosing)
			.then =>
				@stockLocations = _.reject(@stockLocations, {id: -1})

				@afterSave({name: @shop.name, id: @shop.id})
			.catch =>
				@handleErrors()

	findSalesTaxes: ->
		@SalesTaxRepository
			.lookup(@salesTax.address.lookup_address)
			.then (response) =>
				response = response.data

				for rate in response.baseRates
					existingRate = _.find(@shop.sales_taxes, {external_id: rate.external_id}) || {}

					# Extend rate with addition of ID and additional fields from existing rate, while keeping new percentage
					_.extend(
						rate,
						{
							id: @Guid.generate(),
						}
						existingRate,
						{
							type: rate.type,
							percentage: parseFloat((rate.percentage * 100).toFixed(3))
						}
					)

				@salesTax.address.normalized_address = response.addressDetail.normalizedAddress
				@shop.sales_taxes = response.baseRates

				@triggerFormChange()
			.catch (response) =>
				if response.status != 422
					@handleErrors(response)

					return

				@salesTax.address.error = true

	findShopGroups: (searchString) ->
		return @_findEntities searchString, @ShopGroupRepository

	findDataSources: (searchString) ->
		return @_findEntities searchString, @DataSourceRepository

	findProductCategories: (searchString) ->
		return @_findEntities searchString, @ProductCategoryRepository

	setOpeningHoursAllDays: ->
		if @dayTemplate.open_from != null
			for day in @mappedOpeningHours
				day.open_from = @dayTemplate.open_from

		if @dayTemplate.open_to != null
			for day in @mappedOpeningHours
				day.open_to = @dayTemplate.open_to

	addSalesTax: ->
		@shop.sales_taxes.push {
			$new: true
			$order: @salesTax.order.US_OTHER_SALES_TAX
			id: @Guid.generate()
			percentage: 0
		}

		@triggerFormChange()

	removeSalesTax: (salesTax) ->
		salesTax.deleted = true

		@triggerFormChange()

	getNewTable: ->
		return {
			$dirty: false
			$new: true
			id: @Guid.generate()
			shop_id: @shop.id
			name: ''
			description: null
			image: null
			seats: null
			# '1' is used instead of proper boolean value to keep compatibility with
			# Yii boolean validator in backend
			is_active: '1'
		}

	resetNewTable: ->
		@newTable = @getNewTable()

	addNewTable: (table) ->
		@shopTables.unshift(table)

		@resetNewTable()

		@newTableForm.$setPristine()
		@newTableForm.$setUntouched()
		@triggerFormChange()

	setTableModified: (table) ->
		table.$dirty = true

	onUnifiedSalesTaxCategoryChange: ->
		for salesTax in @shop.sales_taxes
			salesTax.excluded_product_categories = angular.copy(@unifiedSalesTaxCategories)

	onTableImageChange: (table) ->
		@triggerFormChange()
		@setTableModified(table)

	removeTable: (table) ->
		if !table.$new
			@tablesToDelete.push(table)

		@shopTables = _.without(@shopTables, table)

		@triggerFormChange()

	addShopVisitorCount: ->
		@editedShopVisitorCounts.push({
			$new: true
			count: 0
			shop_id: @shop.id
			timestamp: moment().unix()
		})

		@triggerFormChange()

	saveShopVisitorCounts: ->
		promises = []

		for shopVisitorCount in @editedShopVisitorCounts
			promises.push @ShopVisitorCountRepository.save shopVisitorCount

		return @ShopVisitorCountRepository
			.all(promises)
			.then =>
				@editedShopVisitorCounts = []
				@shopVisitorCounts = []

				@searchShopVisitorCounts()

	deleteShopVisitorCount: (index, shopVisitorCount) ->
		if shopVisitorCount.id
			@ShopVisitorCountRepository
				.delete shopVisitorCount.id
				.then =>
					@removeShopVisitorCount index
				.catch (response) =>
					@handleErrors(response)
		else
			@removeShopVisitorCount index

	removeShopVisitorCount: (index) ->
		@shopVisitorCounts.splice index, 1

	removeEditedShopVisitorCount: (index) ->
		@editedShopVisitorCounts.splice index, 1

	onShopVisitorCountChange: (shopVisitorCount) ->
		shopVisitorCount.$new = false

		index = _.findIndex(@editedShopVisitorCounts, {id: shopVisitorCount.id})

		if index != -1
			@editedShopVisitorCounts[index] = shopVisitorCount
		else
			@editedShopVisitorCounts.push shopVisitorCount

	searchShopVisitorCounts: ->
		query = @filterDTO.getQuery()
		query.criteria 'shop_id', '=', @shop.id

		@ShopVisitorCountRepository
			.getEntitiesWithCount query, true
			.then (response) =>
				@filterDTO.count = response.count
				@shopVisitorCounts = _.map response.data, (shopVisitorCount) =>
					shopVisitorCount.count = parseInt(shopVisitorCount.count)

					edited = _.findWhere @editedShopVisitorCounts, {id: shopVisitorCount.id}

					if edited?
						return edited
					else
						return shopVisitorCount

	_findEntities: (searchString, repository) ->
		query = repository.createQuery()
		query.criteria 'name', 'LIKE', searchString

		return repository.findByQuery query
